import React from 'react';

export const ProgressBarPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { value, max, color, showLabel, striped } = specificAttrs || {};
  const percentage = ((value || 0) / (max || 100)) * 100;
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div>
      <div style={{
        width: '100%',
        height: '24px',
        background: '#E5E7EB',
        borderRadius: '12px',
        overflow: 'hidden',
        position: 'relative'
      }}>
        <div style={{
          width: `${percentage}%`,
          height: '100%',
          background: striped 
            ? `repeating-linear-gradient(45deg, ${color || '#3B82F6'}, ${color || '#3B82F6'} 10px, rgba(255,255,255,0.2) 10px, rgba(255,255,255,0.2) 20px)`
            : color || '#3B82F6',
          transition: 'width 0.3s',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {showLabel !== false && (
            <span style={{ fontSize: '12px', fontWeight: '600', color: '#FFFFFF' }}>
              {Math.round(percentage)}%
            </span>
          )}
        </div>
      </div>
      </div>
    </div>
  );
};
